import moment from 'moment-timezone';

import type { Moment } from 'moment-timezone';
import type { MultiFlightCalendarInfo } from 'sonata-static-storage/lib/common/common.types';

const DEFAULT_TIMEZONE = 'UTC';

export type LineItemDays = {
  currentDays: number;
  daysPct: number;
  totalDays: number;
};

/** Today's calendar day in the line item timezone, as a local date like the normalized calendar ranges. */
export function getLineItemToday(timezone?: string): Moment {
  const zone = timezone && moment.tz.zone(timezone) ? timezone : DEFAULT_TIMEZONE;
  return moment(moment.tz(zone).format('YYYY-MM-DD'));
}

/**
 * Elapsed and total flight days of a line item, counted over its available (flight) date ranges with both
 * ends included, as the pacing status shows them. Ranges must be normalized to local calendar days.
 */
export function getLineItemDays(
  availableDates: MultiFlightCalendarInfo['availableDates'],
  today: Moment
): LineItemDays {
  const { currentDays, totalDays } = availableDates.reduce(
    (acc, [beginDate, endDate]) => {
      const begin = moment(beginDate).startOf('day');
      const end = moment(endDate).startOf('day');
      const elapsedEnd = moment.min(end, today);

      return {
        currentDays: acc.currentDays + (today.isBefore(begin) ? 0 : elapsedEnd.diff(begin, 'days') + 1),
        totalDays: acc.totalDays + end.diff(begin, 'days') + 1
      };
    },
    { currentDays: 0, totalDays: 0 }
  );

  return {
    currentDays,
    daysPct: totalDays ? Math.round((currentDays * 10000) / totalDays) / 100 : 0,
    totalDays
  };
}
